<template>
    <div>
        <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
            <el-select v-model="currentSchemeId" placeholder="当前方案" style="width: 200px" :disabled="loading"
                @change="loadScheme">
                <el-option v-for="s in schemes" :key="s.id" :label="s.nickname" :value="s.id"></el-option>
            </el-select>
            <el-button type="primary" :loading="loading" @click="openCreateScheme">创建方案</el-button>
            <el-popconfirm title="确定删除当前方案？" confirm-button-text="删除" cancel-button-text="取消" @confirm="deleteScheme"
                :disabled="!currentSchemeId || loading">
                <el-button type="danger" :disabled="!currentSchemeId || loading">删除当前方案</el-button>
            </el-popconfirm>
            <el-button text :loading="loading" @click="refresh">刷新</el-button>
        </div>

        <el-card shadow="never" v-if="currentSchemeId" :loading="loading">
            <template #header>
                <div style="display: flex; justify-content: space-between; align-items: center">
                    <div>
                        章节列表
                        <el-tag v-if="schemeDirty" type="warning" size="small" style="margin-left: 10px">有未保存改动</el-tag>
                    </div>
                    <div>
                        <el-button type="primary" size="small" :disabled="!schemeDirty || loading"
                            @click="saveSchemeChanges">保存改动</el-button>
                        <el-button size="small" :disabled="loading" @click="openSelectChapter">添加章节</el-button>
                    </div>
                </div>
            </template>

            <vue-draggable-next v-if="chapters.length" v-model="chapters" item-key="id" :animation="300" handle=".handle"
                @change="markSchemeDirty">
                <transition-group>
                    <el-card v-for="chapter in chapters" :key="chapter.id" shadow="never" style="margin-bottom: 10px"
                        class="chapter-card">
                        <template #header>
                            <div style="display: flex; align-items: center; justify-content: space-between">
                                <div style="display: flex; align-items: center; gap: 12px">
                                    <div style="display: flex; align-items: center; gap: 4px">
                                        <el-button circle class="handle" icon="Sort" size="small"></el-button>
                                    </div>
                                    <b>{{ displayName(chapter) }}</b>
                                    <el-button circle size="small"
                                        @click="editObjectName(chapter,'chapter','章节')">
                                        <el-icon>
                                            <Edit />
                                        </el-icon>
                                    </el-button>
                                    <el-button link type="primary" size="small" @click="openStories(chapter)">
                                        <el-icon>
                                            <View />
                                        </el-icon> 管理绑定文本
                                    </el-button>
                                </div>
                                <div>
                                    <el-button size="small" @click="openSelectTopic(chapter)">添加主题</el-button>
                                    <el-tag v-if="chapter.__dirty" type="warning" size="small"
                                        style="margin-left: 8px">未保存</el-tag>
                                    <el-button type="primary" size="small" :disabled="!chapter.__dirty || loading"
                                        @click="saveChapterChanges(chapter)">保存改动</el-button>
                                    <el-button type="danger" size="small" @click="removeChapter(chapter)"
                                        icon="Delete">移出方案</el-button>
                                </div>
                            </div>
                        </template>
                        <div style="display: flex; gap: 4px;">
                            <el-button style="margin-right: 8px;" circle size="small"
                                @click="chapter.__fold = !chapter.__fold">
                                <el-icon>
                                    <ArrowRight v-if="chapter.__fold" />
                                    <ArrowDown v-else />
                                </el-icon>
                            </el-button>
                            <el-collapse-transition v-if="chapter.__topics.length">
                                <div v-show="!chapter.__fold" style="flex-basis: 100%;">
                                    <vue-draggable-next v-model="chapter.__topics" item-key="id" :animation="300"
                                        handle=".handle" @change="markChapterDirty(chapter)">
                                        <transition-group>
                                            <el-card v-for="topic in chapter.__topics" :key="topic.id" shadow="never"
                                                style="margin: 10px 0">
                                                <template #header>
                                                    <div style="display: flex; align-items: center; justify-content: space-between">
                                                        <div style="display: flex; align-items: center; gap: 12px">
                                                            <div style="display: flex; align-items: center; gap: 4px">
                                                                <el-button circle class="handle" icon="Sort"
                                                                    size="small"></el-button>
                                                            </div>
                                                            <b>{{ displayName(topic) }}</b>
                                                            <el-button circle size="small"
                                                                @click="editObjectName(topic,'topic','主题')">
                                                                <el-icon>
                                                                    <Edit />
                                                                </el-icon>
                                                            </el-button>
                                                            <el-button link type="primary" size="small"
                                                                @click="openStories(topic)">
                                                                <el-icon>
                                                                    <View />
                                                                </el-icon> 管理绑定文本
                                                            </el-button>
                                                        </div>
                                                        <div>
                                                            <el-button size="small"
                                                                @click="openSelectFigure(topic)">添加手办</el-button>
                                                            <el-tag v-if="topic.__dirty" type="warning" size="small"
                                                                style="margin-left: 8px">未保存</el-tag>
                                                            <el-button type="primary" size="small"
                                                                :disabled="!topic.__dirty || loading"
                                                                @click="saveTopicChanges(chapter, topic)">保存改动</el-button>
                                                            <el-button type="danger" size="small"
                                                                @click="removeTopic(chapter, topic)"
                                                                icon="Delete">移出章节</el-button>
                                                        </div>
                                                    </div>
                                                </template>
                                                <div style="display: flex; gap: 4px">
                                                    <el-button style="margin-right: 8px;" circle size="small"
                                                        @click="topic.__fold = !topic.__fold">
                                                        <el-icon>
                                                            <ArrowRight v-if="topic.__fold" />
                                                            <ArrowDown v-else />
                                                        </el-icon>
                                                    </el-button>
                                                    <el-collapse-transition v-if="topic.__figures.length">
                                                        <div v-show="!topic.__fold" style="flex-basis: 100%;">
                                                            <vue-draggable-next v-model="topic.__figures" item-key="id"
                                                                :animation="300" handle=".handle"
                                                                @change="markTopicDirty(topic)" style="margin-top: 8px"
                                                                class="figure-grid">

                                                                <el-card v-for="figure in topic.__figures"
                                                                    :key="figure.id" shadow="never" class="figure-card">
                                                                    <template #header>
                                                                        <div
                                                                            style="display: flex; justify-content: space-between; align-items: center">
                                                                            <el-button circle class="handle" size="small">
                                                                                <el-icon><Grid /></el-icon>
                                                                            </el-button>
                                                                            <div style="display: flex; align-items: center; gap: 8px; flex: 1; justify-content: center">
                                                                                <b>{{ displayName(figure) }}<span v-if="figure.images?.length">({{figure.images.length}})</span></b>
                                                                                <el-button circle size="small"
                                                                                    @click="editObjectName(figure,'figure','手办')">
                                                                                    <el-icon>
                                                                                        <Edit />
                                                                                    </el-icon>
                                                                                </el-button>
                                                                            </div>
                                                                            <el-button circle type="danger" size="small"
                                                                                @click="removeFigure(topic, figure)">
                                                                                <el-icon>
                                                                                    <Delete />
                                                                                </el-icon>
                                                                            </el-button>
                                                                        </div>
                                                                    </template>
                                                                    <div
                                                                        style="display: flex; justify-content: center; padding: 8px 0">
                                                                        <el-image :src="coverSrc(figure)"
                                                                            style="width: 120px; cursor: pointer;"
                                                                            @click="openFigureImages(figure)"
                                                                            v-if="figure.resource_url"></el-image>
                                                                        <div v-else class="cover-placeholder"
                                                                            @click="openFigureImages(figure)">封面未设置
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        style="text-align: center; padding-bottom: 8px">
                                                                        <el-button size="small"
                                                                            @click="openStories(figure)">
                                                                            <el-icon>
                                                                                <View />
                                                                            </el-icon> 管理绑定文本
                                                                        </el-button>
                                                                    </div>
                                                                </el-card>
                                                            </vue-draggable-next>
                                                        </div>
                                                    </el-collapse-transition>
                                                    <div v-else >暂无手办</div>
                                                </div>
                                            </el-card>
                                        </transition-group>
                                    </vue-draggable-next>
                                </div>
                            </el-collapse-transition>
                            <div v-else >暂无主题</div>
                        </div>
                    </el-card>
                </transition-group>
            </vue-draggable-next>

            <el-empty v-else description="尚未添加章节"></el-empty>
        </el-card>

        <el-empty v-else description="请先创建或选择方案"></el-empty>

        <!-- 创建方案 -->
        <el-dialog v-model="createSchemeDialog" title="创建方案" :before-close="_ => createSchemeDialog = false">
            <el-form :model="schemeForm" ref="schemeFormRef" label-width="100px">
                <el-form-item label="方案名称" prop="nickname" :rules="[{ required: true, message: '请输入方案名称' }]">
                    <el-input v-model="schemeForm.nickname" :disabled="loading"></el-input>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button text @click="createSchemeDialog = false">取消</el-button>
                <el-button type="primary" :loading="loading" @click="createScheme">创建</el-button>
            </template>
        </el-dialog>

        <!-- 选择章节 -->
        <select-item-dialog ref="selectChapter" type="chapter" @bindAndRefresh="onBindAndRefresh"></select-item-dialog>
        <!-- 选择主题 -->
        <select-item-dialog ref="selectTopic" type="topic" @bindAndRefresh="onBindAndRefresh"></select-item-dialog>
        <!-- 选择手办 -->
        <select-item-dialog ref="selectFigure" type="figure" @bindAndRefresh="onBindAndRefresh"></select-item-dialog>

        <!-- 手办图片管理 -->
        <figure-images-dialog ref="figureImages" @updated="onFigureUpdated"></figure-images-dialog>
        <!-- 文本查看 -->
        <copywriting-bind-dialog ref="copywritingBindDialog"></copywriting-bind-dialog>
    </div>

</template>

<script>
import axios from 'ts-axios-new';
import { VueDraggableNext } from 'vue-draggable-next';
import { update } from '../libs/utils';
import { ElMessage } from 'element-plus';
import { ArrowRight, ArrowDown, View, Grid, Delete, Edit } from '@element-plus/icons-vue';
import SelectItemDialog from './chapter/SelectItemDialog.vue';
import FigureImagesDialog from './chapter/FigureImagesDialog.vue';
import CopywritingBindDialog from './chapter/CopywritingBindDialog.vue';

export default {
    name: 'Chapter',
        components: { VueDraggableNext, SelectItemDialog, FigureImagesDialog, CopywritingBindDialog, ArrowRight, ArrowDown, View, Grid, Delete, Edit },
    data() {
        return {
            loading: false,
            schemes: [],
            currentSchemeId: null,
            chapters: [],
            schemeDirty: false,
            createSchemeDialog: false,
            schemeForm: { nickname: '' },
        }
    },
    methods: {
        displayName(item) {
            // 显示名称：优先 stories 的 EN
            if (item && item.stories && item.stories.length) {
                const en = item.stories.find(s => s.EN !== undefined);
                if (en) return en.EN;
            }
            return item.nickname || '未命名';
        },
        coverSrc(figure) {
            return `${this.$root.cdn_url}/${figure.resource_url}`;
        },
        refresh() {
            this.initSchemes();
            if (this.currentSchemeId) this.loadScheme(this.currentSchemeId);
        },
        initSchemes() {
            this.loading = true;
            axios.get('/cms/v1/chapter-scheme', { params: { skip: 0, limit: 100 } }).then(res => {
                this.schemes = (res.data?.data?.list) || (res.data?.data?.chapterSchemeList) || [];
                this.loading = false;
                if (!this.currentSchemeId && this.schemes.length) {
                    this.currentSchemeId = this.schemes[0].id;
                    this.loadScheme(this.currentSchemeId);
                }
            }).catch(e => {
                this.loading = false;
                ElMessage.error('获取方案失败，请稍后重试');
                console.error(e);
            });
        },
        loadScheme(id) {
            this.loading = true;
            // 获取方案详情（章节ID列表），并拉取每个章节详细信息及其主题和手办
            axios.get(`/cms/v1/chapter-scheme/${id}`).then(async res => {
                const scheme = res.data?.data || {};
                const chapterIds = scheme.chapters || [];
                const chapters = [];
                for (const cid of chapterIds) {
                    try {
                        const cRes = await axios.get(`/cms/v1/chapter/${cid}`);
                        const chapter = cRes.data?.data || { id: cid, stories: [], topics: [] };
                        chapter.__topics = [];
                        const topicIds = chapter.topics || [];
                        for (const tid of topicIds) {
                            const tRes = await axios.get(`/cms/v1/topic/${tid}`);
                            const topic = tRes.data?.data || { id: tid, stories: [], figures: [] };
                            topic.__figures = [];
                            const figureIds = topic.figures || [];
                            for (const fid of figureIds) {
                                const fRes = await axios.get(`/cms/v1/figure/${fid}`);
                                const figure = fRes.data?.data || { id: fid, stories: [], images: [], resource_url: null };
                                topic.__figures.push(figure);
                            }
                            chapter.__topics.push(topic);
                        }
                        chapters.push(chapter);
                    } catch (e) { /* ignore single failures */ }
                }
                this.chapters = chapters;
                this.schemeDirty = false;
                this.loading = false;
            }).catch(e => {
                this.loading = false;
                ElMessage.error('获取章节数据失败，请稍后重试');
                console.error(e);
            });
        },

        openCreateScheme() { this.createSchemeDialog = true; },
        createScheme() {
            this.$refs.schemeFormRef.validate(valid => {
                if (!valid) return;
                this.loading = true;
                axios.post('/cms/v1/chapter-scheme', { nickname: this.schemeForm.nickname, username: this.$root.user.name })
                    .then(res => {
                        const created = res.data?.data;
                        if (created) this.schemes.unshift(created);
                        this.createSchemeDialog = false; this.schemeForm.nickname = '';
                        this.currentSchemeId = created?.id || this.currentSchemeId;
                        if (this.currentSchemeId) this.loadScheme(this.currentSchemeId);
                    }).catch(e => {
                        this.loading = false;
                        ElMessage.error('创建方案失败，请稍后重试');
                        console.error(e);
                    }).finally(() => { this.loading = false });
            });
        },
        deleteScheme() {
            if (!this.currentSchemeId) return;
            this.loading = true;
            axios.delete(`/cms/v1/chapter-scheme/${this.currentSchemeId}`).then(_ => {
                const idx = this.schemes.findIndex(s => s.id === this.currentSchemeId);
                if (idx >= 0) this.schemes.splice(idx, 1);
                this.currentSchemeId = this.schemes[0]?.id || null;
                if (this.currentSchemeId) this.loadScheme(this.currentSchemeId); else this.chapters = [];
                this.loading = false;
            }).catch(e => {
                this.loading = false;
                ElMessage.error('删除方案失败，请稍后重试');
                console.error(e);
            });
        },

        markSchemeDirty() { this.schemeDirty = true; },
        markChapterDirty(chapter) { chapter.__dirty = true; },
        markTopicDirty(topic) { topic.__dirty = true; },

        saveSchemeChanges() {
            const ids = this.chapters.map(c => c.id);
            this.loading = true;
            axios.patch(`/cms/v1/chapter-scheme/${this.currentSchemeId}`, {
                username: this.$root.user.name,
                chapters: ids
            }).then(_ => {
                this.schemeDirty = false; this.loading = false;
            }).catch(e => {
                this.loading = false;
                ElMessage.error('保存方案失败，请稍后重试');
                console.error(e);
            });
        },
        saveChapterChanges(chapter) {
            const ids = (chapter.__topics || []).map(t => t.id);
            this.loading = true;
            axios.patch(`/cms/v1/chapter/${chapter.id}`, {
                username: this.$root.user.name,
                topics: ids
            }).then(_ => {
                chapter.__dirty = false; this.loading = false;
            }).catch(e => {
                this.loading = false;
                ElMessage.error('保存章节失败，请稍后重试');
                console.error(e);
            });
        },
        saveTopicChanges(chapter, topic) {
            const ids = (topic.__figures || []).map(f => f.id);
            this.loading = true;
            axios.patch(`/cms/v1/topic/${topic.id}`, {
                username: this.$root.user.name,
                figures: ids
            }).then(_ => {
                topic.__dirty = false; this.loading = false;
            }).catch(e => {
                this.loading = false;
                ElMessage.error('保存主题失败，请稍后重试');
                console.error(e);
            });
        },
        handlerRequestError() {
            this.loading = false;
            ElMessage.error('请求失败，请稍后重试');
        },

        openSelectChapter() {
            this.$refs.selectChapter.open({ parent: { id: this.currentSchemeId, type: 'chapter-scheme', childIds: this.chapters.map(c => ({ id: c.id })) } });
        },
        openSelectTopic(chapter) {
            this.$refs.selectTopic.open({ parent: { id: chapter.id, type: 'chapter', childIds: chapter.__topics.map(t => ({ id: t.id })) } });
        },
        openSelectFigure(topic) {
            this.$refs.selectFigure.open({ parent: { id: topic.id, type: 'topic', childIds: topic.__figures.map(f => ({ id: f.id })) } });
        },
        openStories(item) { this.$refs.copywritingBindDialog.open(item); },
        openFigureImages(figure) { this.$refs.figureImages.open(figure); },

        onBindAndRefresh(parent) {
            if (parent.type === 'chapter-scheme') {
                this.loadScheme(this.currentSchemeId);
            } else if (parent.type === 'chapter') {
                console.log("刷新章节", parent);
                const chapter = this.chapters.find(c => c.id === parent.id);
                console.log("刷新章节2", chapter);
                if (chapter) this.loadChapter(chapter);
            } else if (parent.type === 'topic') {
                for (const chapter of this.chapters) {
                    const topic = chapter.__topics.find(t => t.id === parent.id);
                    if (topic) { this.loadTopic(chapter, topic); break; }
                }
            }
        },
        async loadChapter(chapter) {
            const res = await axios.get(`/cms/v1/chapter/${chapter.id}`);
            const data = res.data?.data || { topics: [] };
            chapter.__topics = [];
            for (const tid of (data.topics || [])) {
                const tRes = await axios.get(`/cms/v1/topic/${tid}`);
                const t = tRes.data?.data || { id: tid, stories: [], figures: [] };
                t.__figures = [];
                for (const fid of (t.figures || [])) {
                    const fRes = await axios.get(`/cms/v1/figure/${fid}`);
                    t.__figures.push(fRes.data?.data || { id: fid, stories: [] });
                }
                t.__fold = false;   // 主题默认展开
                chapter.__topics.push(t);
            }
            chapter.__dirty = false;
            chapter.__fold = false; // 章节默认展开
        },
        async loadTopic(chapter, topic) {
            const res = await axios.get(`/cms/v1/topic/${topic.id}`);
            const data = res.data?.data || { figures: [] };
            topic.__figures = [];
            for (const fid of (data.figures || [])) {
                const fRes = await axios.get(`/cms/v1/figure/${fid}`);
                topic.__figures.push(fRes.data?.data || { id: fid, stories: [] });
            }
            topic.__dirty = false;
            topic.__fold = false;
        },
        removeChapter(chapter) {
            const i = this.chapters.indexOf(chapter); if (i >= 0) this.chapters.splice(i, 1);
            this.schemeDirty = true;
        },
        removeTopic(chapter, topic) {
            const i = chapter.__topics.indexOf(topic); if (i >= 0) chapter.__topics.splice(i, 1);
            chapter.__dirty = true;
        },
        removeFigure(topic, figure) {
            const i = topic.__figures.indexOf(figure); if (i >= 0) topic.__figures.splice(i, 1);
            topic.__dirty = true;
        },
        editFigureName(figure) {
            this.$prompt('请输入新的手办名称', '编辑手办名称', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValue: figure.nickname || '',
                inputPattern: /\S+/,
                inputErrorMessage: '名称不能为空'
            }).then(({ value }) => {
                this.loading = true;
                axios.patch(`/cms/v1/figure/${figure.id}`, {
                    username: this.$root.user.name,
                    nickname: value
                }).then(res => {
                    figure.nickname = value;
                    this.loading = false;
                    ElMessage.success('名称修改成功');
                }).catch(e => {
                    this.loading = false;
                    ElMessage.error('修改名称失败，请稍后重试');
                    console.error(e);
                });
            }).catch(() => { });
        },
        editObjectName(obj,key,name) {
            this.$prompt(`请输入新的${name}名称`, `编辑${name}名称`, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValue: obj.nickname || '',
                inputPattern: /\S+/,
                inputErrorMessage: '名称不能为空'
            }).then(({ value }) => {
                this.loading = true;
                axios.patch(`/cms/v1/${key}/${obj.id}`, {
                    username: this.$root.user.name,
                    nickname: value
                }).then(res => {
                    obj.nickname = value;
                    this.loading = false;
                    ElMessage.success('名称修改成功');
                }).catch(e => {
                    this.loading = false;
                    ElMessage.error('修改名称失败，请稍后重试');
                    console.error(e);
                });
            }).catch(() => { });
        },
        onFigureUpdated(figure) {
            // replace local figure reference
            const topic = (this.chapters.flatMap(c => c.__topics).find(t => (t.__figures || []).includes(figure)));
            // no-op as update done in dialog via reference
        }
    },
    mounted() {
        this.initSchemes();
    }
}
</script>

<style scoped>
.figure-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 12px;
}

.chapter-card {
    background: var(--el-color-info-light-9);
    border-radius: 6px;
}

.figure-card {
    background: var(--el-color-primary-light-9);
    border-radius: 6px;
}

.cover-placeholder {
    width: 120px;
    height: 80px;
    border: 1px dashed var(--el-border-color);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--el-text-color-secondary);
    cursor: pointer;
}
</style>